import React from 'react';
import { Viewer,SpecialZoomLevel,Worker   } from '@react-pdf-viewer/core';
import '@react-pdf-viewer/core/lib/styles/index.css';
import {useParams} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
type FilePage = {
  fileName: string;
};


const SalesPediaFilePage = () => {
  const {fileName}=useParams<FilePage>();
  return (

    <>
    <PageTitle breadcrumbs={[{title:"Anasayfa",path:"/",isActive:true,isSeparator:false}]} description={"İtalyan Mutfağı"}>{"Döküman Görünteleme"}</PageTitle>

    <div className='d-flex flex-column flex-column-fluid'>
      <div className='col-xxl-12 gy-0 gy-xxl-8'>
        <div className='card card-stretch mb-5 mb-xxl-8'>
          <div className='card-body'>
            <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
              <Viewer fileUrl={process.env.PUBLIC_URL + '/pdf/'+fileName} defaultScale={SpecialZoomLevel.PageFit}/>
            </Worker>
          </div>
        </div>
      </div>
    </div>
    </>
      )

}

export default SalesPediaFilePage